export default "__VITE_ASSET__B8n7bqat__"